
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","viewBox":"0 0 28 28","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#DCDCDD","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M0 27.857l6.429-1.42-5.01-5.008zM26.452 8.37a4.76 4.76 0 001.405-3.387 4.75 4.75 0 00-1.403-3.388l-.19-.192A4.758 4.758 0 0022.878 0h-.002c-1.28 0-2.483.5-3.388 1.405L2.143 18.785l6.928 6.93L26.452 8.37z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/photosForm/edit.svg